import { useContext, useEffect, useState, type FC } from "react";
import MainLayout from "../components/MainLayout";
import { Button, Checkbox, IconButton } from "rsuite";
import { LoadingContext } from "../contexts/LoadingContext";
import { SearchContext } from "../contexts/SearchContext";
import {
  createBrand,
  deleteBrand,
  getBrands,
  updateBrand,
} from "../services/inventory/BrandApi";
import { errorToast } from "../utils/helper-ui";
import { PaginationResponse } from "../objects/pagination";
import { getPagination } from "../utils/helper";
import { Brand } from "../models/inventory/brand";
import { Table, Pagination } from "rsuite";
import PlusIcon from "@rsuite/icons/Plus";
import { BsTrash3 } from "react-icons/bs";
import BrandForm from "../components/features/inventory/BrandForm";
const { Column, HeaderCell, Cell } = Table;
interface BrandPageProps {}

const BrandPage: FC<BrandPageProps> = ({}) => {
  const { search, setSearch } = useContext(SearchContext);
  const { isLoading, setIsLoading } = useContext(LoadingContext);
  const [mounted, setMounted] = useState(false);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(30);
  const [pagination, setPagination] = useState<PaginationResponse>();
  const [brands, setBrands] = useState<Brand[]>([]);
  const [modalFormOpen, setModalFormOpen] = useState(false);
  const [selectedBrand, setSelectedBrand] = useState<Brand>();

  const [checkedKeys, setCheckedKeys] = useState<string[]>([]);
  let checked = false;
  let indeterminate = false;

  if (checkedKeys.length === brands.length) {
    checked = true;
  } else if (checkedKeys.length === 0) {
    checked = false;
  } else if (checkedKeys.length > 0 && checkedKeys.length < brands.length) {
    indeterminate = true;
  }

  const handleCheckAll = (
    value: any,
    checked: boolean,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const keys = checked ? brands.map((item) => item.id) : [];
    setCheckedKeys(keys);
  };
  const handleCheck = (
    value: any,
    checked: boolean,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const keys = checked
      ? [...checkedKeys, value as string]
      : checkedKeys.filter((item) => item !== (value as string));
    setCheckedKeys(keys);
  };

  useEffect(() => {
    setMounted(true);

    return () => {
      setMounted(false);
    };
  }, []);

  useEffect(() => {
    if (!mounted) return;
    fetchData();
  }, [mounted, search, page, size]);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const res = await getBrands({ page, size, search });
      const resJson = await res.json();
      //   console.log(data);
      setBrands((prev) => [...prev, ...resJson.data.items]);
      setPagination(getPagination(resJson.data));
    } catch (error) {
      errorToast(`${error}`);
    } finally {
      setIsLoading(false);
    }
  };

  const removeBrand = async (brand: Brand) => {
    try {
      setIsLoading(true);
      if (
        window.confirm(
          `Are you sure you want to delete brand with name ${brand.name}?`
        )
      ) {
        await deleteBrand(brand.id!);
        fetchData();
      }
    } catch (error) {
      errorToast(`${error}`);
    } finally {
      setIsLoading(false);
    }
  };
  const saveBrand = async (brand: Brand) => {
    try {
      setIsLoading(true);
      if (selectedBrand) {
        await updateBrand(selectedBrand.id!, brand);
      } else {
        await createBrand(brand);
      }
      setModalFormOpen(false);
      setSelectedBrand(undefined);
      setBrands([]);
      fetchData();
    } catch (error) {
      errorToast(`${error}`);
    } finally {
      setIsLoading(false);
    }
  };
  const renderHeader = () => (
    <div className="flex flex-row justify-between items-center px-2">
      <h1 className="text-2xl font-semibold">Brand</h1>
      {/* button */}
      <div>
        <IconButton
          size="sm"
          appearance="primary"
          color="green"
          icon={<PlusIcon />}
          onClick={() => setModalFormOpen(true)}
        >
          Create Brand
        </IconButton>
      </div>
    </div>
  );
  return (
    <MainLayout header={renderHeader()}>
      <div className="w-full overflow-y-auto">
        <table className="w-full text-sm">
          <thead>
            <tr>
              <th className="px-4 py-2 text-left border bg-gray-50 w-32">
                <Checkbox
                  inline
                  checked={checked}
                  indeterminate={indeterminate}
                  onChange={handleCheckAll}
                />
              </th>
              <th className="px-4 py-2 text-left border bg-gray-50">Name</th>
              <th className="px-4 py-2 text-left border bg-gray-50">
                Description
              </th>
              <th className="px-4 py-2 text-left border bg-gray-50">Logo</th>
              <th className="px-4 py-2 text-left border bg-gray-50">Website</th>
              {/* <th className="px-4 py-2 text-left border bg-gray-50">Email</th>
              <th className="px-4 py-2 text-left border bg-gray-50">Phone</th>
              <th className="px-4 py-2 text-left border bg-gray-50">Address</th>
              <th className="px-4 py-2 text-left border bg-gray-50">
                Contact Person
              </th>
              <th className="px-4 py-2 text-left border bg-gray-50">
                Contact Position
              </th>
              <th className="px-4 py-2 text-left border bg-gray-50">
                Contact Title
              </th>
              <th className="px-4 py-2 text-left border bg-gray-50">
                Contact Note
              </th>
              <th className="px-4 py-2 text-left border bg-gray-50">
                Registration Number
              </th> */}
              <th className="px-4 py-2 text-left border bg-gray-50">Action</th>
            </tr>
          </thead>
          <tbody>
            {brands.map((brand, i) => (
              <tr key={brand.id}>
                <td className="px-4 py-2 border">
                  <Checkbox
                    value={brand.id}
                    inline
                    onChange={handleCheck}
                    checked={checkedKeys.some((item) => item === brand.id)}
                  />
                  {i + 1}
                </td>

                <td className="px-4 py-2 border">
                  <div
                    className="hover:underline cursor-pointer font-semibold"
                    onClick={() => {
                      setSelectedBrand(brand);
                      setModalFormOpen(true);
                    }}
                  >
                    {brand.name}
                  </div>
                </td>
                <td className="px-4 py-2 border">{brand.description}</td>
                <td className="px-4 py-2 border" >
                  {brand.logo && (
                    <img src={brand.logo} className="w-[100px]"  alt="logo" />
                  )}
                </td>
                <td className="px-4 py-2 border">{brand.website}</td>
                {/* <td className="px-4 py-2 border">{brand.email}</td>
                <td className="px-4 py-2 border">{brand.phone}</td>
                <td className="px-4 py-2 border">{brand.address}</td>
                <td className="px-4 py-2 border">{brand.contact_person}</td>
                <td className="px-4 py-2 border">{brand.contact_position}</td>
                <td className="px-4 py-2 border">{brand.contact_title}</td>
                <td className="px-4 py-2 border">{brand.contact_note}</td> */}
                {/* <td className="px-4 py-2 border">
                  {brand.registration_number}
                </td> */}
                <td className="px-4 py-2 border">
                  <BsTrash3
                    className="text-red-500 hover:text-red-800"
                    size={16}
                    onClick={() => removeBrand(brand)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {!pagination?.last && (
        <div className="flex justify-center my-2">
          <Button
            onClick={() => {
              setPage((pagination?.page ?? 0) + 1);
            }}
          >
            Load more
          </Button>
        </div>
      )}
      {/* <Table minHeight={700} data={brands} onRowClick={(data, i) => {}}>
        <Column width={50} align="center" fixed>
          <HeaderCell style={{ padding: 0 }}>
            <div style={{ lineHeight: "40px" }}>
              <Checkbox
                inline
                checked={checked}
                indeterminate={indeterminate}
                onChange={handleCheckAll}
              />
            </div>
          </HeaderCell>
          <Cell style={{ padding: 0 }}>
            {(rowData) => (
              <div style={{ lineHeight: "46px" }}>
                <Checkbox
                  value={rowData.id}
                  inline
                  onChange={handleCheck}
                  checked={checkedKeys.some((item) => item === rowData.id)}
                />
              </div>
            )}
          </Cell>
        </Column>
        <Column width={70} align="center" fixed>
          <HeaderCell>No</HeaderCell>
          <Cell>
            {(rowData) => (
              <div>
                {(page - 1) * size + brands.indexOf(rowData as Brand) + 1}
              </div>
            )}
          </Cell>
        </Column>

        <Column width={200} resizable fixed>
          <HeaderCell>Name</HeaderCell>
          <Cell>
            {(rowData) => (
              <div
                className="hover:underline cursor-pointer font-semibold "
                onClick={() => {
                  setSelectedBrand(rowData as Brand);
                  setModalFormOpen(true);
                }}
              >
                {rowData.name}
              </div>
            )}
          </Cell>
        </Column>

        <Column width={200} resizable>
          <HeaderCell>Description</HeaderCell>
          <Cell dataKey="description" />
        </Column>

        <Column width={100} resizable>
          <HeaderCell>Logo</HeaderCell>
          <Cell style={{ padding: 0 }}>
            {(rowData) =>
              rowData.logo && (
                <img src={rowData.logo} style={{ height: 50 }} alt="logo" />
              )
            }
          </Cell>
        </Column>

        <Column width={200} resizable>
          <HeaderCell>Website</HeaderCell>
          <Cell dataKey="website" />
        </Column>

        <Column width={200} resizable>
          <HeaderCell>Email</HeaderCell>
          <Cell dataKey="email" />
        </Column>

        <Column width={200} resizable>
          <HeaderCell>Phone</HeaderCell>
          <Cell dataKey="phone" />
        </Column>
        <Column width={200} resizable>
          <HeaderCell>Address</HeaderCell>
          <Cell dataKey="address" />
        </Column>

        <Column width={200} resizable>
          <HeaderCell>Contact Person</HeaderCell>
          <Cell dataKey="contact_person" />
        </Column>

        <Column width={200} resizable>
          <HeaderCell>Contact Position</HeaderCell>
          <Cell dataKey="contact_position" />
        </Column>

        <Column width={200} resizable>
          <HeaderCell>Contact Title</HeaderCell>
          <Cell dataKey="contact_title" />
        </Column>

        <Column width={200} resizable>
          <HeaderCell>Contact Note</HeaderCell>
          <Cell dataKey="contact_note" />
        </Column>

        <Column width={200} resizable>
          <HeaderCell>Registration Number</HeaderCell>
          <Cell dataKey="registration_number" />
        </Column>
        <Column width={200} resizable>
          <HeaderCell>Action</HeaderCell>
          <Cell>
            {(rowData) => (
              <BsTrash3
                className="text-red-500 hover:text-red-800"
                size={16}
                onClick={() => removeBrand(rowData as Brand)}
              />
            )}
          </Cell>
        </Column>
      </Table> */}
      {/* <div style={{ padding: 20 }}>
        <Pagination
          prev
          next
          first
          last
          ellipsis
          boundaryLinks
          maxButtons={5}
          size="xs"
          layout={["total", "-", "limit", "|", "pager", "skip"]}
          total={pagination?.total ?? 0}
          limitOptions={[10, 30, 50]}
          limit={pagination?.size}
          activePage={pagination?.page}
          onChangePage={setPage}
          onChangeLimit={setSize}
        />
      </div> */}
      <BrandForm
        brand={selectedBrand}
        open={modalFormOpen}
        onClose={() => {
          setModalFormOpen(false);
          setSelectedBrand(undefined);
        }}
        onSubmit={saveBrand}
      />
    </MainLayout>
  );
};
export default BrandPage;
